



























































































































































import Vue from 'vue';
// import {
//   addTurnGSL, getGSL, delTurnGSL, yieldGSL, nextGSL, timeLeftGSL,
// } from '@/api/gsl';
import { mapState } from 'vuex';
import negara from '@/const/country.json';
// import { getAllDelegates } from '@/api/delegates';
import Autocomplete from '@/components/Autocomplete/index.vue';
import CardStack from '@/components/CardStack/index.vue';
import Timer from '@/components/Timer/index.vue';
import Queue from '@/components/Queue/index.vue';
import Confirmation from '@/components/Confirmation/index.vue';
// eslint-disable-next-line no-unused-vars
import { delegatesType, gslType, websocketType } from '@/types/api';

export default Vue.extend({
  name: 'GSL',
  components: {
    CardStack,
    Timer,
    Queue,
    Autocomplete,
    Confirmation,
  },
  data() {
    return {
      delegatesData: [] as delegatesType.getAllDelegates[],
      gslData: null as gslType.getGSL | null,
      currentCountry: 0 as number, // cardstacks display
      selected: null as 0 | 1 | 2 | 3 | null,
      yieldDelegate: '' as string,
      yieldCountry: '' as string,
      showConfirm: false as boolean,
      showInput: false as boolean,
      gslCurrent: null as number | null, // current in GET gsl
      newArr: [] as unknown as (delegatesType.getAllDelegates & Partial<gslType.getTurn>)[],
      showYield: false as boolean,
      showQueue: false as boolean,
      prevent: false as boolean,
      config: {
        // @ts-ignore
        handler: this.outside,
        events: ['click', 'touchstart', 'touchmove'],
      },
      actions: {
        Restart: true as boolean,
        'View Notes': false as boolean,
        'Clear Yield': true as boolean,
        'Remove From Queue': true as boolean,
      },
    };
  },
  methods: {
    stopCaucus(): void {
      const stop = {
        session: 'caucus',
        command: 'stop',
      };
      const vue = this;
      this.$socket.send(JSON.stringify(stop));
      vue.$socket.addEventListener('message', function onmessage() {
        vue.$socket.removeEventListener('message', onmessage);
        setTimeout(() => {
          vue.toggleActive();
        }, 1000);
      });
    },
    outside(): void {
      this.showYield = false;
      this.showQueue = false;
    },
    context(): void {
      switch (this.contextData.action) {
        case 'Remove From Queue':
          // this.deleteTurn(this.contextData.index);
          this.deleteTurn();
          break;
        case 'Clear Yield':
          this.changeYield(0);
          break;
        case 'View Notes':
          // TODO:view notes
          break;
        case 'Restart':
          this.restart();
          break;
        default:
      }
    },
    newCountryList(): void {
      const list: { name: string }[] = [];
      this.delegatesData.forEach((item) => {
        let data: any = negara.find((e) => e.name === item.country);
        if (data) {
          list.push(data);
        } else {
          data = {
            name: item.country,
          };
          list.push(data);
        }
      });
      this.$store.commit('countryList', list);
    },
    newGSLList(l: gslType.getGSL) {
      this.newArr.length = 0;
      let data: delegatesType.getAllDelegates & Partial<gslType.getTurn>;
      for (let i = 0; i < l.queue.length; i += 1) {
        [data] = this.delegatesData.filter((e) => e._id === l.queue[i].delegate_id);
        if (data) {
          data.time_start = l.queue[i].time_start;
          data.time_left = l.queue[i].time_left;
          let y: { yield: string } = {
            yield: '',
          };
          if (!l.queue[i].yield) {
            delete data.yield;
          } else if (l.queue[i].yield
            && (l.queue[i].yield!.toLowerCase() === 'questions' || l.queue[i].yield!.toLowerCase() === 'chair')) {
            y = { yield: l.queue[i].yield as string };
          } else if (l.queue[i].yield) {
            const [delY] = this.delegatesData.filter((e) => e._id === l.queue[i].yield);
            y = { yield: delY.country };
          }
          data = { ...data, ...y };
          this.newArr.push(data);
        }
      }
      this.$store.commit('gslList', this.newArr);
    },
    async changeYield(selected: 0 | 1 | 2 | 3): Promise<void> {
      try {
        let order: number = 0;
        // let data: gslType.yieldGSL = {
        //   order,
        //   yield: '',
        // };
        if (this.gslCurrent !== null) order = this.gslCurrent + 1;
        // if (this.socket.order === order) {
        // switch (selected) {
        //   case 0:
        //     data = {
        //       order,
        //       yield: '',
        //     };
        //     break;
        //   case 1:
        //     data = {
        //       order,
        //       yield: 'Chair',
        //     };
        //     break;
        //   case 2:
        //     data = {
        //       order,
        //       yield: 'Questions',
        //     };
        //     break;
        //   case 3:
        //     data = {
        //       order,
        //       yield: this.yieldDelegate,
        //       time_left: this.socket.time,
        //     };
        //     this.yieldCountry = '';
        //     break;
        //   default:
        // }
        // await yieldGSL(this.$route.params.id, data);
        if (selected === 1) {
          this.$socket.send(JSON.stringify({
            session: 'gsl',
            command: 'stop',
            order,
          }));
          // await timeLeftGSL(this.$route.params.id, {
          //   order,
          //   time_left: this.socket.time,
          // });
          if (this.gslCurrent as number < this.gslList.length - 1) {
            // await nextGSL(this.$route.params.id);
          }
        }
        if (selected === 2) {
          this.$socket.send(JSON.stringify({
            session: 'gsl',
            command: 'pause',
            order,
          }));
        }
        this.updateGSL();
      } catch (err) {
        console.error(err);
      }
      this.showYield = false;
    },
    async next(): Promise<void> {
      try {
        const next = {
          session: 'gsl',
          command: 'stop',
          order: this.gslCurrent,
        };
        this.$socket.send(JSON.stringify(next));
        if (this.gslCurrent !== null) {
          // await timeLeftGSL(this.$route.params.id, {
          //   order: this.gslCurrent + 1,
          //   time_left: this.socket.time,
          // });
          // if (this.gslCurrent < this.gslList.length - 1) await nextGSL(this.$route.params.id);
          this.updateGSL();
        }
      } catch (err) {
        console.error(err);
      }
    },
    restart(): void {
      const data = {
        session: 'gsl',
        command: 'stop',
        order: this.gslCurrent,
      };
      this.$socket.send(JSON.stringify(data));
      setTimeout(() => {
        if (this.gslCurrent !== null) {
          const play = {
            session: 'gsl',
            command: 'start',
            time: this.gslList[this.gslCurrent].time_start,
            order: this.gslCurrent,
          };
          this.$socket.send(JSON.stringify(play));
        }
      }, 500);
    },
    // async deleteTurn(index: number): Promise<void> {
    deleteTurn(): void {
      try {
        // await delTurnGSL(this.$route.params.id, index + 1);
        this.updateGSL();
      } catch (err) {
        console.error(err);
      }
    },
    // async addQueue([country, time]: [string, number]): void {
    addQueue([country]: [string, number]): void {
      // try {
      const [id] = this.delegatesData.filter((obj) => obj.country === country);
      // const data = {
      //   delegate_id: id._id,
      //   time_start: time,
      //   time_left: time,
      //   yield: '',
      // };
      if (id) {
        // await addTurnGSL(this.$route.params.id, data);
        this.updateGSL();
      }
      this.showQueue = false;
      // } catch (err) {
      //   console.error(err);
      // }
    },
    updateGSL(): void {
      // try {
      // const list = await getGSL(this.$route.params.id);
      const list = {
        current: 0,
        length: 4,
        queue: [
          {
            order: 1,
            delegate_id: 'usa',
            time_start: 90,
            time_left: 90,
            yield: 'chair',
          },
          {
            order: 2,
            delegate_id: 'indonesia',
            time_start: 90,
            time_left: 90,
            yield: 'chair',
          },
          {
            order: 3,
            delegate_id: 'canada',
            time_start: 90,
            time_left: 90,
            yield: 'indonesia',
          },
          {
            order: 4,
            delegate_id: 'bulgaria',
            time_start: 90,
            time_left: 90,
            yield: 'chair',
          },
        ],
      };
      if (list !== null) {
        this.gslData = list;
        this.newGSLList(list);
      }
      if (this.gslData && this.gslCurrent !== this.gslData.current) {
        this.currentCountry = this.gslData.current;
        this.gslCurrent = this.gslData.current;
      }
      // } catch (err) {
      //   console.error(err);
      // }
    },
    toggleActive(): void {
      const data: websocketType.send = {
        session: 'gsl',
        order: 0,
      };
      if (this.gslCurrent !== null && this.socket.state === 2) {
        data.command = 'start';
        data.time = this.gslList[this.gslCurrent].time_left;
        data.order = this.gslCurrent;
      } else if (this.gslCurrent !== null && this.socket.state === 1) {
        data.command = 'resume';
        data.order = this.gslCurrent;
      } else if (this.gslCurrent !== null) {
        data.command = 'pause';
        data.order = this.gslCurrent;
      }
      this.$socket.send(JSON.stringify(data));
    },
    select(i: 0 | 1 | 2 | 3): void {
      this.selected = i;
    },
    move(index: number): void {
      let j: number = 0;
      if (this.gslData) {
        j = Math.min(Math.max(parseInt(index.toString(), 10), 0), this.gslData.queue.length - 1);
      }
      this.currentCountry = j;
    },
    yieldInput(country: string): void {
      if (country.length > 0) {
        this.selected = 3;
      } else {
        this.selected = 0;
      }
      const [del] = this.delegatesData.filter((obj) => obj.country === country);
      this.yieldDelegate = del._id;
      this.yieldCountry = country;
    },
    getDelegatesID(name: string): string {
      const data = negara.find((obj) => obj.name === name);
      if (data) return data['alpha-2'];
      return 'ad';
    },
    sortCountry(items: delegatesType.getAllDelegates[]): delegatesType.getAllDelegates[] {
      items.sort((a, b) => {
        const nameA = a.country.toUpperCase();
        const nameB = b.country.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      return items;
    },
    async updateDelegatesData(): Promise<void> {
      // try {
      // const delegates = await getAllDelegates(this.$route.params.id);
      const delegates = this.delStore;
      if (delegates !== null) {
        this.delegatesData = this.sortCountry(delegates);
        this.newCountryList();
      }
      // } catch (err) {
      //   console.error(err.response);
      // }
    },
  },
  async created() {
    this.$root.$on('context', this.context);
    try {
      await this.updateDelegatesData();
      this.updateGSL();
    } catch (err) {
      console.error(err);
    }
  },
  computed: {
    ...mapState({
      socket: (state: any) => state.Socket.message,
      countryList: (state: any) => state.Delegates.countryList,
      gslList: (state: any) => state.Delegates.gslList,
      widthWindow: (state: any) => state.Global.widthWindow,
      contextData: (state: any) => state.Global.contextData,
      delStore: (state: any) => state.Delegates.delegates as delegatesType.getAllDelegates[],
    }),
  },
  beforeCreate() {
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
    this.$root.$off('context', this.context);
  },
});
